import { Component, Input, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedHttpService } from '../../services/shared-http.service';
import { CaseService } from '../../services/case.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-facts',
    templateUrl: './facts.component.html',
    styleUrls: ['./facts.component.scss']
})
export class FactsComponent implements OnInit {
    caseFactList: any;
   
    closeResult: string = '';
    factId: any;
    factIdEdit: any;
    descriptionEdit: any;
    factcaseEdit: any;

    factItem: any;
    caseStatusId: any;
    casefacts: any;

    constructor(private modalService: NgbModal, public sharedService: SharedHttpService, public toastr: NotificationService, public caseService: CaseService) { }
    @Input() loadDataFP: Observable<any>;

    facts: any = [];
    factsBool: Boolean[] = []

    SuggestionDecision: any = "";
    caseObject: any;


    fact: any = "";
    showDeleteFactButton = false;
    selectedFact;

  



    ngOnInit(): void {
        this.loadDataFP.subscribe((data) => {
            setTimeout(() => {
this.loadData();
            }, 100);

        });


    }



    loadData() {
        this.caseObject = this.caseService.getCaseData();
        
        this.sharedService.get(`api/Fact/GetAll?skip=0&take=1500`).subscribe(res => {
            this.facts = res.data;
            this.facts.map(fact => {
                if (this.casefacts.indexOf(fact.description) != -1) {
                    fact.added = true;
                } else {
                    fact.added = false;
                }
            })

        });

      
        this.casefacts = this.caseObject.facts;
        this.SuggestionDecision = this.caseObject.suggestionDecision;
       
        if (this.casefacts == null) {
            this.casefacts = "";
        }



        this.sharedService.get(`api/CaseFact/GetAll?skip=0&take=1500&Filter.Filters[0].operator=eq&Filter.Filters[0].value=${this.caseObject.caseId}&Filter.Filters[0].field=caseId`).subscribe(res => {
            this.caseFactList = res.data;
            console.log("caseFactList", this.caseFactList);
        });

     

    }



    addFact(mymodal) {
        this.open(mymodal);
    }

    
clear(){ 
    this.casefacts='';
    this.fact='';
    this.modalService.dismissAll();

}

    onAddFact() {
        this.sharedService.post("api/CaseFact/Insert", [
            {
                "factId": this.selectedFact.factId,
                "description": this.casefacts,
                "caseId": this.caseObject.caseId
            }
        ]
        ).subscribe((response) => {
            this.sharedService.showSuccessKey("CreatedSuccessfully");
           this.modalService.dismissAll();

            this.loadData();
        },
            (error) => {
                console.error('error')
                this.sharedService.showErrorKey("Notsaved");
            });

    }
    
    UpdateFact(item,mymodal) {
        console.log('factItem',item);
        
        this.factItem=item;
        this.factIdEdit=item.factId;
        this.descriptionEdit=item.description;
        this.factcaseEdit=item.caseFactId;
        this.open(mymodal);
    }

    factSelectedEdit(e){
        if (e) {
            this.factIdEdit=e.factId;    
        }
        
        this.facts.map(f => {
            if (f.description == e.description) {
                f.added = true;
            }

        })
     if (this.descriptionEdit != "" && this.descriptionEdit != null)
            this.descriptionEdit =  e.description;
        else
            this.descriptionEdit = e.description;

    }
    onUpdateFact() {
        let updateUrl='api/CaseFact/Update';
        let objectBody={'caseFactId':this.factcaseEdit,'factId':this.factIdEdit,'description':this.descriptionEdit,"caseId": this.caseObject.caseId};
        this.sharedService.put(updateUrl,[objectBody]
        ).subscribe((response) => {
            this.sharedService.showSuccessKey("EditedSuccessfully");
            this.modalService.dismissAll();

            this.loadData();
        },
            (error) => {
                console.error('error')
                // this.toastr.showError(this.sharedService.getTranslatedKey("Notsaved"), this.sharedService.getTranslatedKey("Success"));


            });

    }
    

    DeleteFact(factId: any, mymodal) {
        this.openDel(mymodal);
        this.factId = factId;

    }
    openDel(content: any) {

        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    
        });
      }

    onDeleteFact() {
        let url = 'api/CaseFact/Delete'
        this.sharedService.delete(url, [this.factId]).subscribe(

            (response) => {
                this.sharedService.showSuccessKey("DeletedSuccessfully");
                this.modalService.dismissAll();

                this.loadData();
            },
            (error) => {
                console.error('error')
                this.sharedService.showErrorKey("Notsaved");
            });
    }



   

    open(content: any) {

        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true,size: 'lg' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }


    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

  

    
   


    factSelected(e) {
        if (e) {
            this.selectedFact = e;
        }
        this.facts.map(f => {
            if (f.description == this.fact) {
                f.added = true;
            }
        })
        if (this.casefacts != "" && this.casefacts != null)
            this.casefacts =  this.fact;
        else
            this.casefacts = this.fact;

    }
    

    

    saveSuggestionDecision() {
        this.sharedService.post("api/Case/SuggestedDecision", {
            "suggestedDecision": this.SuggestionDecision,
            "caseId": this.caseObject.caseId
        }).subscribe((response) => {                       
            
            this.sharedService.get(`api/Case/GetCaseDetails?ecaseId=${this.caseObject.eCaseId}`).subscribe((res) => {
                console.log("CaseDetails", res);
                this.caseService.setCaseData(res);
            });
    
            this.sharedService.showSuccessKey("CreatedSuccessfully");
        },
          (error) => {                              
            console.error('error')
            this.sharedService.showErrorKey("Notsaved");       
          });
      
    }

    saveFactsAndResons() {
        this.sharedService.post("api/Case/AddFactsAndResons", {
            "facts": this.casefacts,
            // "reasons": this.caseresons,
            "suggestionDecision": this.SuggestionDecision,
            "caseId": this.caseObject.caseId
        }).subscribe((response) => {
            //this.caseObject = this.caseService.getCaseData();


            this.sharedService.get(`api/Case/GetCaseDetails?eCaseId=${this.caseObject.caseIdEncrypt}`).subscribe((res) => {
                console.log("CaseDetails", res);
                this.caseService.setCaseData(res);
            });

            this.sharedService.showSuccessKey("FactsAndResonsCreatedSuccessfully");
        },
            (error) => {
                console.error('error')
               this.sharedService.showErrorKey("Notsaved");
            });

    }


}
